import { useMemo } from "react";
import getProductDefaultSelect from "components/Pages/Finance/_hook/getProductDefaultSelect";

export default (items, isSortByApy) => {
  const resAry = useMemo(() => {
    if (!isSortByApy) return items;

    const convertAry = [];
    const getApyMax = (financialProducts) => {
      const selectProduct = getProductDefaultSelect(financialProducts);
      let apyMax = 0;
      selectProduct.apyList &&
        selectProduct.apyList.map((apyObj) => {
          apyObj.annualized > apyMax && (apyMax = apyObj.annualized);
        });
      return apyMax;
    };

    items.map((doc) => {
      if (doc.productCollections.length === 1) {
        doc.apyMax = getApyMax(doc.productCollections[0].financialProducts);
      } else {
        doc.productCollections.sort((a, b) => {
          let apyMax_a = 0;
          if (a.apyMax || a.apyMax === 0) {
            apyMax_a = a.apyMax;
          } else {
            apyMax_a = a.apyMax = getApyMax(a.financialProducts);
          }

          let apyMax_b = 0;
          if (b.apyMax || b.apyMax === 0) {
            apyMax_b = b.apyMax;
          } else {
            apyMax_b = b.apyMax = getApyMax(b.financialProducts);
          }

          return apyMax_b - apyMax_a;
        });
        doc.apyMax = doc.productCollections[0].apyMax;
      }
      convertAry.push(doc);
    });

    convertAry.sort((a, b) => b.apyMax - a.apyMax);
    return convertAry;
  }, [items, isSortByApy]);

  console.log("useSortByApy ===", resAry);
  return resAry;
};
